import { Component, OnInit } from '@angular/core';


export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = [
    { path: '/dashboard',     title: 'Dashboard',         icon:'nc-bank',       class: '' },
    { path: '/users',          title: 'Users',      icon:'nc-single-02',  class: '' },
    { path: '/fund-requests',         title: 'Fund Requests',             icon:'nc-credit-card',    class: '' },
    { path: '/withdrawal-requests',         title: 'Withdrawal Requests',        icon:'nc-money-coins',    class: '' },
    { path: '/verification-requests',         title: 'Verification Requests',        icon:'nc-check-2',    class: '' },
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
    }
}
